import {
  config,
  datadogLog,
  generateRequestId,
  REQUEST_ID_HEADER_NAME,
} from '@finn/ui-utils/ssr';
import axios from 'axios';

import { AddonsData } from '../types/addons';

const {
  getBranchAwareEnv,
} = require('../../../ui-utils/src/lib/getBranchAwareEnv');

const baseURL = getBranchAwareEnv('ADDONS_API_URL');
const xApiKey = getBranchAwareEnv('ADDONS_API_KEY');

const instance = axios.create({
  baseURL,
  validateStatus: (status) => [200, 201].includes(status),
  transformRequest: (data, headers) => {
    headers[REQUEST_ID_HEADER_NAME] = generateRequestId();
    headers['x-finn-actor'] = config.UA_FE_ACTOR;
    headers['x-api-key'] = xApiKey;

    return data;
  },
});

export const extractConfigId = (productId: string) => {
  const matches = productId.match(/\d+/g);

  return matches ? matches[matches.length - 1] : undefined;
};

export const getAvailabelProductAddons = async (
  productId: string
): Promise<AddonsData> => {
  const isUid = Boolean(Number(productId));
  const configId = isUid ? productId : extractConfigId(productId);

  const response = await instance.get<AddonsData>(
    `/b2c/products/${configId}/addons`
  );

  return response.data;
};

export const getAppliedAddons = async (subscriptionId: string) => {
  const response = await instance.get<AddonsData>(
    `/addons/b2c/subscription/${subscriptionId}/addons`
  );

  return response.data;
};

export const attachAddonToProduct = async ({
  subscriptionId,
  addonId,
  isDeductible,
}: {
  subscriptionId: string;
  addonId: string;
  isDeductible: boolean;
}) => {
  // for some reason using the instance.post() method generates errors for this endpoint, so we're using axios directly
  const response = await axios.post(
    `${baseURL}/addons/b2c/subscription/${subscriptionId}/addons/${addonId}`,
    {},
    {
      headers: {
        [REQUEST_ID_HEADER_NAME]: generateRequestId(),
        'Content-Type': 'application/json',
        'x-api-key': xApiKey,
        'x-finn-actor': config.UA_FE_ACTOR,
      },
    }
  );

  try {
    if (isDeductible) {
      await axios.post(
        'https://hook.finn.integromat.cloud/et79a57xj9u2cprqibvr6sennpxvcvw4',
        {
          dealId: subscriptionId,
          insuranceOption: addonId,
        }
      );
    }
  } catch (error) {
    datadogLog({
      message: 'insurance addon webhook call failed',
      error: JSON.stringify(error, null, 2),
      dealId: subscriptionId,
      insuranceOption: addonId,
    });
  }

  return response.data;
};

export const cancelAddon = async ({
  subscriptionId,
  addonId,
  reason,
}: {
  subscriptionId: string;
  addonId: string;
  reason?: string;
}) => {
  const response = await instance.post(
    `/addons/b2c/subscription/${subscriptionId}/addons/${addonId}/cancel?reason=${reason || 'unknown'}`
  );

  return response.data;
};
